(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ydl-volume-pricing"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.ydlVolumePricingReady === 'true') return;

      const data = root.querySelector('[data-ydl-variant-prices]');
      const form = root.closest('form[action*="/cart/add"]') || root.closest('.product-form');
      if (!data || !form) return;

      let prices;
      try {
        prices = JSON.parse(data.textContent);
      } catch {
        return;
      }

      const update = () => {
        const variantInput = form.querySelector('[name="id"]');
        const cents = prices[String(variantInput?.value)];
        if (!Number.isFinite(cents)) return;

        const currency = root.dataset.currency;
        const locale = root.dataset.locale || document.documentElement.lang || 'en';
        const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        });

        root.querySelectorAll('[data-ydl-tier-price]').forEach((price) => {
          const discount = Number(price.dataset.discount);
          const discountedCents = cents - Math.floor(cents * discount / 100);
          price.textContent = `${formatter.format(discountedCents / 100)} ${currency}`;
        });
      };

      form.addEventListener('change', update);
      update();
      root.dataset.ydlVolumePricingReady = 'true';
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-ydl-volume-pricing]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
